import { render, staticRenderFns } from "./DatePickerTable.vue?vue&type=template&id=20f879df&"
import script from "./DatePickerTable.vue?vue&type=script&lang=js&"
export * from "./DatePickerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports